import moment from 'moment';

/**
 * @export
 * @class Notice
 * 공지사항 영역
 */
export default class Notice {
  constructor() {
    // 필요 data 유효 확인
    const {
      htStaticData: { bIsDeliveryDeal, bIsLocalDeal, htDealContentInfo },
    } = TMON.oApp.htStorage;

    const { announcementCategory: announcementsData = [] } = TMON.htStaticData.htDealInfo;

    const { dealHotNotices, extendPeriodLogs } = htDealContentInfo;

    const {
      data: deliveryHolidayNoticeData,
    } = TMON.oApp.htStorage.deliveryHolidayNotice;

    const filteredAnnouncements = announcementsData.filter(
      item => moment(item.endDate) - moment(TMON.currentTimeTimestamp, 'x') > 0
    );

    // 공지사항이 비어있으면 영역의 처리를 하지 않음
    if (
      // 카테고리 공지사항이 없고
      !(filteredAnnouncements && filteredAnnouncements.length > 0) &&
      // 딜 공지사항이 없고
      !(dealHotNotices && dealHotNotices.length > 0) &&
      // 로컬 딜이거나 (로컬 딜에서는 딜 연장 공지 노출하지 않음)
      (bIsLocalDeal ||
        // 로컬 딜이 아니고 딜 연장 공지사항이 없으면
        (!bIsLocalDeal &&
          !(extendPeriodLogs && extendPeriodLogs.length > 0))) &&
      // 배송딜이면서 배송휴무데이터 존재
      !(
        bIsDeliveryDeal &&
        deliveryHolidayNoticeData &&
        deliveryHolidayNoticeData.holidayStartDd
      )
    ) {
      return;
    }

    this.welWrapper = $('#_wrapNotice');

    this.render();
    this.setEvent();

    this.processAfterRender();

    this.welWrapper.show();
  }

  setEvent() {
    // toggle eventListener 등록
    this.welWrapper.on('click', '[data-role=toggleButton] a', e => {
      if (e.currentTarget.href.indexOf('#none') > -1) {
        e.preventDefault();
      }
      this.onClickToggle(
        $(e.currentTarget).closest('[data-role=toggleButton]')
      );
    });
    // 모바일일 경우 a 태그가 없기에 따로 toggle eventListener 등록
    this.welWrapper.on('click', '#mDeliveryHoliday button', e => {
      this.onClickToggle(
        $(e.currentTarget).closest('[data-role=toggleButton]')
      );
    });
    // 링크 이동 eventListener 등록
    this.welWrapper.on('click', 'a:not(dt>a)', this.onClickLink);
    // 공지 이미지 로드 후 더보기 버튼 렌더링
    $('#_wrapNotice img').each(function() {
      $(this).on('load', function() {
        if (TMON.oApp.oDealContents) {
          TMON.oApp.oDealContents.renderViewMoreBtn();
        }
      });
    });
  }

  clearEvent() {
    if (this.welWrapper) {
      this.welWrapper.off('click', '[data-role=toggleButton] a');
      this.welWrapper.off('click', '#mDeliveryHoliday button');
      this.welWrapper.off('click', 'a:not(dt>a)');
    }
  }

  /**
   * toggle eventListener
   */
  onClickToggle = wel => {
    wel.toggleClass('open');
  };

  /**
   * 앱에서 링크 이동 eventListener
   */
  onClickLink = e => {
    e.stopPropagation();

    if (TMON.view_mode === 'app') {
      const sLink = TMON.util.aup(
        $(e.currentTarget).attr('href'),
        TMON.sAppQuery
      );
      e.preventDefault();
      TMON.app.callApp(
        'webview',
        'showNaviWebView',
        '티몬',
        sLink,
        false,
        false,
        true
      );
    }
  };

  render() {
    const {
      htStaticData: { bIsDeliveryDeal, bIsLocalDeal, htDealContentInfo },
    } = TMON.oApp.htStorage;
    const { announcementCategory: announcementsData = [] } = TMON.htStaticData.htDealInfo;

    const { dealHotNotices } = htDealContentInfo;

    let { extendPeriodLogs } = htDealContentInfo;

    let {
      data: deliveryHolidayNoticeData,
    } = TMON.oApp.htStorage.deliveryHolidayNotice;

    // 로컬 딜이면 연장공지사항 데이터를 비움 (로컬 딜에서는 딜 연장 공지 노출하지 않음)
    if (bIsLocalDeal) {
      extendPeriodLogs = [];
    }

    // 배송딜아니면 데이터 null 처리 (배송딜에서만 노출)
    if (!bIsDeliveryDeal) {
      deliveryHolidayNoticeData = null;
    }

    const filteredAnnouncements = announcementsData.filter(
      item => moment(item.endDate) - moment(TMON.currentTimeTimestamp, 'x') > 0
    );

    const hasAnnouncements =
      filteredAnnouncements && filteredAnnouncements.length > 0;
    const hasDeliveryHolidayNotice =
      deliveryHolidayNoticeData && deliveryHolidayNoticeData.holidayStartDd;
    const hasDealHotNotices = dealHotNotices && dealHotNotices.length > 0;
    const hasExtendPeriodLogs = extendPeriodLogs && extendPeriodLogs.length > 0;

    let isAnnouncementFirst = false;
    let isDealHotNoticeFirst = false;
    let isExtendPeriodLogFirst = false;

    if (hasAnnouncements) {
      isAnnouncementFirst = true;
    } else if (!hasDeliveryHolidayNotice) {
      if (hasDealHotNotices) {
        isDealHotNoticeFirst = true;
      } else if (hasExtendPeriodLogs) {
        isExtendPeriodLogFirst = true;
      }
    }
    const sHtml = `
            <ul>
                ${
                  /*
                   * 전체공지 (긴급공지 / 카테고리 공지)
                   * announcements API로 가져온 데이터로 html 생성
                   *
                   * DB에서 불러온 값을 그대로 내려주기에 웹에서 사용을 위한 처리가 필요
                   * www/SG/lib/Tmon/Deal.php 에 있던 기존 로직.
                   * getCategoryHotNotice > getCategoryHotNoticeForWeb > _markNewNoticeFormat
                   */
                  hasAnnouncements
                    ? filteredAnnouncements
                        .map((item, idx) => {
                          let sNoticeHtml = item.msg.replace(
                            /href="admin_script"/gm,
                            ''
                          );
                          sNoticeHtml = sNoticeHtml.replace(
                            / style="font-size:12px"/gm,
                            ''
                          );

                          // 공지사항 내용은 이미지 혹은 텍스트 (긴급 공지의 경우 이미지로 내려올 수 있다.)
                          const notice = item.msg
                            ? /<dd>([\s\S]*?)<\/dd>/gm.exec(sNoticeHtml)
                            : `<img alt="긴급공지 이미지" src="https://img1.tmon.kr${item.imageUrl}"/>`;
                          const noticedDateStr = `${
                            item.startDate.split(' ')[0]
                          } / ${item.startDate.split(' ')[1].substring(0, 5)}`;

                          return `<li ${
                            isAnnouncementFirst && idx === 0
                              ? ' id="FirstNoticeItem"'
                              : ''
                          }" data-role="toggleButton" class="toggle c">
                                    <dl>
                                        <dt>
                                            <a href="#none">
                                                <span class="bu">내용 닫기</span>
                                                <strong> ${item.title} </strong>
                                                <span class="date"> <em>${noticedDateStr}</em> 공지</span>
                                            </a>
                                        </dt>
                                        <dd> ${
                                          typeof notice === 'object'
                                            ? notice[1]
                                            : notice
                                        }</dd>
                                    </dl>
                                </li>`;
                        })
                        .join('')
                    : ''
                }
                ${
                  /*
                   * 배송 휴무공지
                   * 데이터 개수는 항상 1개만 내려오도록 되있음
                   * deliveryHolidayNotice API로 가져온 데이터로 html 생성
                   * 공지 순서와 상관없이 폴딩 오픈된 상태로 로딩됨
                   */
                  hasDeliveryHolidayNotice
                    ? `${this.renderDeliveryHoliday(deliveryHolidayNoticeData)}`
                    : ''
                }
                ${
                  /*
                   * 딜 개별공지
                   * htDealContentInfo.dealHotNotices로 html 생성
                   *
                   * DB에서 불러온 값을 그대로 내려주기에 웹에서 사용을 위한 처리가 필요
                   * www/SG/lib/Tmon/Deal.php 에 있던 기존 로직.
                   */
                  hasDealHotNotices
                    ? dealHotNotices
                        .map(item => {
                          let sNoticeHtml = item.notice.replace(
                            /href="admin_script"/gm,
                            ''
                          );
                          sNoticeHtml = sNoticeHtml.replace(/\n/gm, '');
                          sNoticeHtml = sNoticeHtml.replace(/\t/gm, '');
                          sNoticeHtml = sNoticeHtml.replace(/<dl>/gm, '');
                          sNoticeHtml = sNoticeHtml.replace(/<\/dl>/gm, '');
                          sNoticeHtml = sNoticeHtml.replaceAll('http://', 'https://');

                          if (sNoticeHtml.indexOf('<dd>') <= 0) {
                            sNoticeHtml = sNoticeHtml.replace(
                              /<\/dt>\s<p>/gm,
                              '</dt><p>'
                            );
                            const splitedContents = sNoticeHtml.split(
                              '</dt><p>'
                            );

                            if (splitedContents[1]) {
                              const splitedTail = splitedContents[1].split(
                                '</p>'
                              );
                              sNoticeHtml = `${splitedContents[0]}</dt><dd><p>${splitedTail[0]}</p></dd>${splitedTail[1]}`;
                            }
                          }

                          return `<li ${
                            isDealHotNoticeFirst ? 'id="FirstNoticeItem"' : ''
                          } data-role="toggleButton" class="toggle d">${sNoticeHtml}</li>`;
                        })
                        .join('')
                    : ''
                }
                ${
                  /*
                   * 판매기간 연장 자동 공지
                   * htDealContentInfo.extendPeriodLogs로 html 생성
                   *
                   * DB에서 불러온 값을 그대로 내려주기에 웹에서 사용을 위한 처리가 필요
                   * www/SG/lib/Tmon/Deal.php 에 있던 기존 로직.
                   */
                  hasExtendPeriodLogs
                    ? extendPeriodLogs
                        .map((item, idx) => {
                          const splitedDate = item.extendedDate.split(' ');
                          const noticedDateStr = `${
                            splitedDate[0]
                          } / ${splitedDate[1].substring(0, 5)}`;

                          const periodExtendReasonText = item.extendTitle.replace(
                            /많은/gm,
                            '<br/> 많은'
                          );

                          return `<li ${
                            isExtendPeriodLogFirst && idx === 0
                              ? 'id="FirstNoticeItem"'
                              : ''
                          } data-role="toggleButton" class="toggle e">
                                    <dl>
                                        <dt>
                                            <a href="#none">
                                                <span class="bu">내용 닫기</span>
                                                <strong>판매기간이 연장되었습니다.</strong>
                                                <span class="date"><em> ${noticedDateStr} </em> 공지</span>
                                            </a>
                                        </dt>
                                        <dd>
                                            <span>${periodExtendReasonText}</span>
                                            <br /><br />
                                            기존: ${item.previousEndDate} <br />
                                            변경: ${item.extendEndDate}
                                        </dd>
                                    </dl>
                                </li>`;
                        })
                        .join('')
                    : ''
                }
            </ul>
        `;

    this.welWrapper.html(sHtml);
  }

  processAfterRender() {
    // table, tr, td에 html 속성으로 width 가 내려오는것을 리셋
    $(
      '.product_notice table, .product_notice table tr, .product_notice table td'
    ).css({
      width: 'auto',
      'max-width': '100%',
      'padding-left': '4px',
      'padding-right': '4px',
    });

    // 첫번째 공지사항 열린 상태로 변경
    this.onClickToggle($('#FirstNoticeItem'));
  }

  renderDeliveryHoliday(deliveryHolidayNoticeData) {
    const noticeDate = deliveryHolidayNoticeData.updateDt;
    const isUpdated =
      deliveryHolidayNoticeData.createDt !== noticeDate ? '(수정)' : '';
    const period = `${deliveryHolidayNoticeData.holidayStartDd} ~ ${deliveryHolidayNoticeData.holidayEndDd}`;
    const closingDate = `${deliveryHolidayNoticeData.closingDd} ${deliveryHolidayNoticeData.closingTm}`;
    const reopenDate = `${deliveryHolidayNoticeData.reopenDd}`;
    const commonArea = `<div class="notice_table_wrap">
                                <dl class="notice_table">
                                    <div class="notice_table_bind">
                                        <dt class="notice_table_title">휴무기간<br>배송안내</dt>
                                        <dd class="notice_table_content"><div class="notice_table_text"><span class="point_color_blue">${period}</span> 기간 동안 배송이 불가하여, 아래와 같이 배송일정이 변경됨을 안내 드리며, 구매 시 참고 부탁드립니다.</div></dd>
                                    </div>
                                    <div class="notice_table_bind">
                                        <dt class="notice_table_title">주문마감${
                                          TMON.oApp.sPlatform === 'PW'
                                            ? ' '
                                            : '<br>'
                                        }안내</dt>
                                        <dd class="notice_table_content"><div class="notice_table_text"><span class="point_color_blue">${closingDate}</span> 까지 결제 완료된 주문은 휴무 일 전 배송이 가능합니다</div></dd>
                                    </div>
                                    <div class="notice_table_bind">
                                        <dt class="notice_table_title">출고 안내</dt>
                                        <dd class="notice_table_content"><div class="notice_table_text"><span class="point_color_blue">${closingDate}</span> 까지 결제가 되지 않은 주문은 휴무 후 <span class="point_color_blue">${reopenDate}</span> 부터 순차 출고 예정입니다.</div></dd>
                                    </div>
                                </dl>
                            </div>
                            <p class="notice_text">
                            해당 기간은 배송지연 보상 일 수 계산에서 제외됨을 안내드립니다.<br>티몬과 함께 즐거운 쇼핑되세요!
                            </p>`;

    if (TMON.oApp.sPlatform === 'PW') {
      return `<li data-role="toggleButton" class="toggle open">
                        <div class="admin_notice_new">
                            <ul>
                                <li class="selected">
                                    <dt>
                                        <a><span class="bu">내용 닫기</span><strong>배송 휴무 안내</strong> <span class="date"><em><span>${noticeDate}</span></em> 공지${isUpdated}</span></a>
                                    </dt>
                                    <dd>
                                        ${commonArea}
                                    </dd>
                                </li>
                            </ul>
                        </div>
                    </li>`;
    }
    return `<li id="mDeliveryHoliday" data-role="toggleButton" class="toggle open">
                    <button type="button" class="notice_view">
                        <h3 class="tit">배송 휴무 안내</h3>
                        <p class="date">${noticeDate} 공지${isUpdated}</p>
                    </button>
                    <div class="notice_detail">
                        ${commonArea}
                    </div>
                </li>`;
  }
}
